/**
 * Aperture — símbolo de marca ARKU (brand v3 navy).
 * Fuente de verdad compartida entre CRM y landing.
 * default: circle (ink) + sweep (navy) + center disk (ink)
 * inverse: para fondos oscuros (paper + tint)
 * mono: una sola tinta (paper)
 */
interface ApertureProps {
  size?: number;
  variant?: 'default' | 'inverse' | 'mono';
}

export function ApertureLogo({ size = 28, variant = 'default' }: ApertureProps) {
  const outer = variant === 'default' ? '#0E0F12' : variant === 'inverse' ? '#F4F3EE' : '#F4F3EE';
  const sweep = variant === 'default' ? '#1B3A5C' : variant === 'inverse' ? '#7AA0CC' : '#F4F3EE';
  const inner = variant === 'default' ? '#0E0F12' : variant === 'inverse' ? '#F4F3EE' : '#F4F3EE';
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" aria-hidden="true">
      <circle cx="26" cy="26" r="24" stroke={outer} strokeWidth="2.5" />
      <path d="M26 4 A22 22 0 0 1 48 26" stroke={sweep} strokeWidth="3.5" />
      <circle cx="26" cy="26" r="14" stroke={outer} strokeWidth="2" />
      <circle cx="26" cy="26" r="3.5" fill={inner} />
    </svg>
  );
}
